(($) => {
    // TODO

    // Select all links with hashes
    $(document)
    // Remove links that don't actually link to anything
        .on('click', 'a[href*="#"]:not([href="#"]):not([href="#0"])', function (ev) {
            // On-page links
            if (!(location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname)) return;

            // Figure out element to scroll to
            let $target = $(ev.currentTarget.hash);
            $target = $target.length ? $target : $('[name=' + ev.target.hash.slice(1) + ']');

            // Does a scroll target exist?
            if (!$target.length) return;

            // Only prevent default if animation is actually gonna happen
            ev.preventDefault();

            // Figure out scrolling container
            let $elScroll = $target.closest('.item-picker__content');
            if (!$elScroll.length) $elScroll = $('html, body');

            let offsetTarget = $target.position().top,
                offsetContainer = $elScroll.scrollTop(),
                offsetDelta = offsetTarget + offsetContainer;

            $elScroll.animate({scrollTop: offsetDelta},
                {
                    duration: 400,
                    complete: () => {  // Callback after animation

                        // Must change focus!
                        $target.focus();

                        // Checking if the target was focused
                        if ($target.is(":focus")) return false;

                        $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                        // $target.focus(); // Set focus again
                    }
                }
            );

        });

})(jQuery);